import { BaseContainerModel } from '../../base-container.model';
import { bl_aat_claim_ocr_scanned_doc_hdr_RowClass, bl_aat_claim_ocr_scanned_doc_line_RowClass} from '../../../dbschema';

export class ClaimOcrScannedDocContainerModel extends BaseContainerModel {
  bl_aat_claim_ocr_scanned_doc_hdr: bl_aat_claim_ocr_scanned_doc_hdr_RowClass = new bl_aat_claim_ocr_scanned_doc_hdr_RowClass();
  bl_aat_claim_ocr_scanned_doc_lines: bl_aat_claim_ocr_scanned_doc_line_RowClass[] = [];
}
